import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />

      <main>
        <div className="grid grid-cols-1 overflow-x-hidden ">
          <div>
            <div className="md:px-8 lg:px-12   ">
              <div className="pt-6">
                <div className="">
                  <div
                    __typename="ComponentComponentsText"
                    container="[object Object]"
                    id={5535}
                  >
                    <div className="prose prose-plain max-w-full prose-h1:font-heading text-left text-base font-normal p-4">
                      <h1>Terms &amp; Conditions</h1>
                      <h2>IMPORTANT LEGAL NOTICE</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          These are the legal terms and conditions under which
                          we or the Concessionaire Brands supply the products
                          (“Products”) listed on our website{" "}
                          <Link onClick={toTop} to="/">
                            www.boventraix.space
                          </Link>{" "}
                          (“our site”) to you. Please read these terms and
                          conditions (“Terms and Conditions”) carefully before
                          ordering any Products from our site. By placing an
                          order to purchase any or our Products, you agree to be
                          bound by these Terms and Conditions together with our
                          Website Terms Of Useour Privacy Policy, our Privacy
                          Notice,and our Return Policy , regardless of whether
                          or not you choose to register with us. These Terms and
                          Conditions tell you who we are, how we will provide
                          Products to you, how you and we may change or end the
                          contract, what to do if there is a problem and other
                          important information.
                        </p>
                      </div>
                      <h2>1. INFORMATION ABOUT US AND HOW TO CONTACT US</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          1.1.{" "}
                          <Link onClick={toTop} to="/">
                            www.boventraix.space
                          </Link>{" "}
                          is operated by boventraix.space UK Limited (“We”). We
                          are a company registered in England and Wales under
                          company number 05723154 and with our registered office
                          at 49/51 Dale Street, Manchester, England M1 2HF. Our
                          UK VAT number is 185 4874 61. Options to contact us
                          can be found on our{" "}
                          <Link onClick={toTop} to="/contact">
                            contact us
                          </Link>{" "}
                          section.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          1.2. If we need to contact you, we will do so by
                          writing to you at the e-mail address or postal address
                          you provided to us in your order, unless you have
                          asked us to contact you by any other means. When we
                          use the words “writing” or “written” in these terms,
                          this includes e-mails.
                        </p>
                      </div>
                      <h2>2. THE CONTRACT AND CONCESSIONAIRE BRANDS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          2.1. Where you place an order on our site for a
                          Product sold by boventraix, the contract for the sale
                          of the Product is between you and boventraix; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          2.2. Where you place an order on our site for a
                          Product sold by Debenhams DBZ Limited, 49-51 Dale
                          Street, Manchester, M1 2HF registered no. 14840908
                          (the "Concessionaire Brand"), boventraix acts as the
                          Concessionaire Brand's disclosed agent and not as
                          principal. This means the Contract for the sale of
                          such Products is made between you and the
                          Concessionaire Brand, on the terms and conditions set
                          out in this document. Other than concluding sales as a
                          disclosed agent on the Concessionaire Brands’ behalf,
                          boventraix has no responsibility to you in respect of
                          Contracts made with the Concessionaire Brand and all
                          references in the remainder of these terms and
                          conditions to "We", "us" or "our" shall be deemed to
                          refer to the Concessionaire Brand.
                        </p>
                      </div>
                      <h2>3. SERVICE AVAILABILITY</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          3.1. Some restrictions are placed on the extent to
                          which We accept orders from specific countries. These
                          restrictions can be found on our “Deliveries” page{" "}
                          <Link onClick={toTop} to="/shipping">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <h2>4. YOUR STATUS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          4.1. You may only purchase Products from us if:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (a) you are legally capable of entering into a binding
                          contract with us (for example, in England and Wales
                          you must be at least 18 years old);
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (b) you are an authorised user of the credit or debit
                          card used to pay for your order; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (c) you are resident in a country that we deliver to
                          (please see our “Deliveries” page for further
                          information).
                        </p>
                      </div>
                      <h2>5. HOW THE CONTRACT IS FORMED BETWEEN YOU AND US</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          5.1. Once you have placed your order, you should
                          receive an e-mail from us acknowledging that We have
                          received your order (but please contact us if you do
                          not receive this e-mail). Please note this does not
                          mean that your order has been accepted. All orders are
                          subject to availability and acceptance by us (which We
                          may refuse for any reason).
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          5.2. After you submit your order, We immediately
                          contact your bank or card issuer for authorisation to
                          take payment from your account. We will not process
                          your order until payment has been received in full. If
                          we accept your order We will confirm this to you by
                          sending you a further e-mail confirming the Product is
                          being processed ready for dispatch at which point the
                          contract between us ("Contract") will be formed.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          5.3. As soon as you place your order, we start to
                          process your order which means you will not be able to
                          change it before delivery, but you may be able to
                          return your Products under clause 10 of these terms
                          and conditions or under our Returns Policy{" "}
                          <Link onClick={toTop} to="/returns">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          5.4. From time to time We may make minor changes to a
                          Product to reflect changes in relevant laws and
                          regulatory requirements.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          5.5. These terms and conditions, and any Contract
                          between us, are only in the English language.
                        </p>
                      </div>
                      <h2>6. DELIVERY</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.1. Your order will be fulfilled by the delivery date
                          set out in the Dispatch Confirmation or, if no
                          delivery date is specified, then as soon as reasonably
                          possible (depending on the delivery service you have
                          selected). In any event, delivery will take place no
                          more than 30 days after the day your Contract is
                          entered into.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.2. If no one is available at your address to take
                          delivery and the Products cannot be posted through
                          your letterbox or left in a safe place, after three
                          failed attempts, we may end the Contract and clause 13
                          will apply.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.3. Delivery of your order will be complete when We
                          deliver the Products to the address you gave us and
                          the Products will be your responsibility from that
                          time.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.4. You will own the Products once We have received
                          payment in full.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.5. The images of the Products on our site and in our
                          other advertising materials are for illustrative
                          purposes only. Your Products may vary slightly from
                          those images. Although We have made every effort to
                          display and print the colours of the Products
                          accurately, We cannot guarantee that your computer's
                          display of the pictures, or the pictures in our other
                          advertising materials, accurately reflect the colours
                          of the Products that will be delivered to you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.6. Please note postcode restrictions apply and that
                          orders placed with Brand Concessionaires can only be
                          delivered within the UK mainland and Northern Ireland.
                          Check your eligibility .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.7. Working Days excludes Sunday and Bank Holidays
                          and Saturdays for some Concessionaire Brands.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.8. If you wish to dispute delivery of your order,
                          you have 28 days starting from the day that the
                          tracking status for you order is updated by the
                          carrier as fulfilled (i.e. updated as delivered to the
                          address set out in the Dispatch Confirmation). If your
                          tracking doesn’t confirm your order has been delivered
                          please note you have 90 days from your last tracking
                          event to contact us. We reserve the right to request
                          evidence, before issuing any refund of the price paid
                          and/or any associated delivery costs.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          6.7. In addition, if you order Products from us for
                          delivery to a destination outside the UK:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (a) your order may be subject to import duties and
                          taxes which are applied when it reaches the delivery
                          destination. Please note that we have no control over
                          these charges and we cannot predict their amount. You
                          will be responsible for payment of any such import
                          duties and taxes. Please contact your local customs
                          office for further information before placing your
                          order. We will not be liable or responsible if you do
                          not pay any such import duties or taxes;
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (b) you must comply with all applicable laws and
                          regulations of the country for which the Products are
                          destined. We will not be liable or responsible if you
                          break any such law; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (c) please see our Returns Policy{" "}
                          <Link onClick={toTop} to="/returns">
                            here
                          </Link>{" "}
                          for details on returning any Products to us from a
                          destination outside the UK
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Next Day excludes most Concessionaire Brand items.
                        </p>
                      </div>
                      <h2>7. INTERNATIONAL DELIVERY</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you order Products from us for delivery to a
                          destination outside the UK:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          7.1. your order may be subject to import duties and
                          taxes which are applied when it reaches the delivery
                          destination. Please note that We have no control over
                          these charges and We cannot predict their amount. You
                          will be responsible for payment of any such import
                          duties and taxes. Please contact your local customs
                          office for further information before placing your
                          order. We will not be liable or responsible if you do
                          not pay any such import duties or taxes;
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          7.3 you must comply with all applicable laws and
                          regulations of the country for which the Products are
                          destined. We will not be liable or responsible if you
                          break any such law; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          7.4 if you return any Products to us from a
                          destination outside the UK, please ensure that the
                          return parcel is marked clearly with the wording
                          “Return to supplier” or wording having similar effect.
                        </p>
                      </div>
                      <h2>8. PRICE AND PAYMENT</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.1. The price payable for the Products shall be as
                          shown on our site in pounds sterling (GBP), although
                          please see clause 8.5 for what happens if We discover
                          an error in the price of any Product you order. Prices
                          advertised on our site include UK VAT at the relevant
                          rate chargeable for the time being, but exclude
                          delivery charges which are payable in addition and
                          shown separately during the checkout process.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.2. We can change the prices on our site at any time
                          without notice, but changes will not affect orders
                          which We have already accepted. However, if the rate
                          of VAT changes after the date of your order, We will
                          adjust the rate of VAT you pay unless you have already
                          paid for the Products in full before the change in VAT
                          takes effect.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.3. We accept payment by debit card or credit card
                          and Klarna. We accept the following cards: Visa, VISA
                          Electron, Mastercard, Maestro, American Express.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.4. You must pay for the Products (including all
                          applicable delivery charges), and We will charge the
                          card you have chosen to use to pay for your order once
                          you reach the final billing page and submit your
                          order. We immediately contact your bank or card issuer
                          for authorisation to take payment from your account.
                          If you pay using Klarna, such payment will subject to
                          additional terms between you and Klarna, available at
                          . See for further information about Klarna. For more
                          information about how Klarna will handle your personal
                          data see their Privacy Policy, available at .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.5. If We accept and process your order where there
                          is a pricing error that is obvious and unmistakable
                          and which could reasonably have been recognised by you
                          as a mispricing, We may end the Contract, refund to
                          you any sums you have paid under the Contract and
                          require the return of any Products provided to you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.6. Our liability to pay for the Product is satisfied
                          once boventraix has received your payment in full in
                          accordance with clause 8.4 above, irrespective of
                          whether the Product is sold by boventraix or the
                          Concessionaire Brand. boventraix is entitled to use
                          the proceeds of your payment at its absolute
                          discretion, to the extent that such use will have no
                          effect on the satisfaction of your liability in
                          relation to your purchase of the Product.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          8.7. If you wish to apply a voucher code to your
                          order, you must enter the relevant code during the
                          online checkout process.Up to five voucher codes can
                          be used per order and additional terms and conditions
                          may apply in respect of each voucher code. We reserve
                          the right to decline to accept any voucher code that
                          is invalid for your order or that has expired.
                        </p>
                      </div>
                      <h2>
                        9. YOUR RIGHT TO CANCEL THE CONTRACT (UK AND EEA
                        CUSTOMERS ONLY)
                      </h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.1. If you are a consumer in the UK or European
                          Economic Area (“EEA”), you have a legal right to
                          cancel a Contract if you change your mind until 14
                          days after you receive (or someone you nominate
                          receives) the Products, unless the Products are split
                          into several deliveries over different days. In this
                          case you have until 14 days after the day you (or
                          someone you nominate) receives the last Product
                          ordered under that Contract.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.2. You are entitled to exercise your rights to
                          cancel an order in respect of any one, or all Products
                          from an order. Please see our Returns Policy{" "}
                          <Link onClick={toTop} to="/returns">
                            here
                          </Link>{" "}
                          for more details.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.3. You may be entitled to a repair, replacement, or
                          refund where you receive faulty Products, or your
                          Products become faulty. Please let us know as soon as
                          reasonably possible after becoming aware of a fault
                          with your Product. For further information, please see
                          our Returns Policy{" "}
                          <Link onClick={toTop} to="/returns">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.4. The right to cancel a contract under clause 9
                          does not apply to cosmetics and pierced jewellery or
                          on swimwear and lingerie if the hygiene seal is not in
                          place or has been broken; vitamins and supplements,
                          medicines and toiletries if the hygiene or product
                          seal has been broken or is no longer in place or if
                          the product is not in its original packaging (if
                          applicable), unless faulty; returned shoes must not
                          have been worn outside, however they may have been
                          tried on indoors (but not on any stone or tiled
                          floors). Any returned footwear must be in its original
                          box (if any) and original shoe or dust bag (if any);
                          items of homeware including bedlinen, mattresses and
                          toppers, and pillows must be unused and in their
                          original unopened packaging; electrical products may
                          have their own specific warranty period or additional
                          terms relating to returns, please see further details
                          on any product page and in some cases, electrical
                          products may not be returned if the packaging has been
                          tampered with or opened, or if any hygiene seal (where
                          applicable) has been tampered with, or is broken;
                          furniture items must be in new and unused condition,
                          unassembled and in their original packaging;
                          perishable items (including but not limited to food,
                          alcohol or flowers); unwrapped computer software
                          (including CDs and DVDs); custom-made items and
                          personalised items; and vitamins or supplements where
                          the seal has been broken.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.5. If you wish to cancel a Contract under clauses
                          9.1 to 9.3 above, please let us know within the
                          timescales set out under those clauses. There are a
                          few ways to contact us, you can:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (a) Email us:{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          (b) WhatsApp us: +44 333 311 0802 (c) Write to us via
                          post: Las Liebres 160B, Las Gaviotas, 96536
                          Coatzacoalcos, Ver., Mexico.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.6. You may use a copy of the cancellation form
                          available here but you are not required to do so.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.7. For full details on returns and items that are
                          excluded from being returned, please see our Returns
                          Policy{" "}
                          <Link onClick={toTop} to="/returns">
                            here
                          </Link>
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          9.8. If you cancel a Contract under clause 9.1 before
                          you receive the Products, but after the Products have
                          been dispatched to you, you must return them to us
                          once received. You must send off the Products for
                          return within 14 days of telling us that you wish to
                          cancel the Contract. If you choose to return the
                          Products using any method other than one of our
                          nominated carriers (available via our UK returns
                          service) you will remain responsible for the Products
                          including for any loss or damage, until we receive
                          them. Please see our Returns Policy here for further
                          information about how to return Products to us. If you
                          wish to cancel a Contract with the Concession Brand,
                          you will need to follow the instructions provided in
                          your parcel delivery note. If you do not use this
                          service in accordance with instructions set out in
                          delivery note, then you will be responsible for the
                          cost of returning the Products to us.
                        </p>
                      </div>
                      <h2>10. RETURNS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          10.1. As an alternative to using your rights under
                          clause 8.1, you may wish to return an item using our
                          UK returns service. For further information on returns
                          please see our{" "}
                          <Link onClick={toTop} to="/returns">
                            Returns Policy
                          </Link>
                          . The process for returning your Products is dependent
                          on whether the individual item was supplied by
                          Debenhams or by a Concession Brand.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          10.2. If you choose to return the Products using any
                          method other than one of our nominated carriers
                          (available via our UK returns service), you will
                          remain responsible for the Products, including for any
                          loss or damage, until we receive them.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          10.3. Where we suspect fraudulent activity, including
                          but not limited to circumstances where there are
                          suspicious claims relating to orders having been
                          placed, but not received, or if we suspect that you
                          are returning items after they have been used or worn,
                          or if any item's label or tag has been removed, or
                          items returned do not match what you ordered, we
                          reserve the right to withhold refunds and block your
                          account (and any associated accounts) from placing
                          orders in future. If this happens to you and you think
                          we’ve made a mistake, you can contact us and we will
                          discuss the matter with you further.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          10.4. Please note a returns charge of £1.99 per parcel
                          will be deducted from your refund amount.
                        </p>
                      </div>
                      <h2>11. YOUR RIGHT FOR A REFUND (UK CUSTOMERS ONLY)</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          11.1. If you are a consumer in the UK and you cancel
                          your Contract under clause 9.1, We will:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (a) refund you the price you paid for the Products.
                          However, please note that We may reduce your refund to
                          reflect any reduction in the value of the Products, if
                          this has been caused by you handling them in a way
                          which would not be permitted in a shop. If We refund
                          you the price paid before We are able to inspect the
                          Products and later discover you have handled them in
                          an unacceptable way, you must pay us an appropriate
                          amount; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (b) refund any charges you have paid for delivery of
                          the Products to you, although the maximum refund for
                          delivery costs will be the least expensive delivery
                          method We offer to your delivery destination; and
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (c) Any customers who opt for credit return will
                          receive 20% extra on their refund price. The cost of
                          your returns amount will be deducted from the full
                          amount of your refund. We are sorry but any customers
                          who made their purchase using store credit or a gift
                          card will not receive the 20% extra on their refund
                          price.”
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (d) make any refunds due to you by the method you used
                          for payment if you opt for a cash return:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          ㅤ(i) 14 days after the day on which We receive the
                          Products back from you or, if earlier, the day on
                          which you provide us with evidence that you have sent
                          the Products back to us; or
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          ㅤ(ii) 14 days after you inform us of your decision to
                          cancel the Contract.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          11.2. Please see our Returns Policy for more
                          information about returns and refunds.
                        </p>
                      </div>
                      <h2>12. FAULTY PRODUCTS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          12.1. If you are a consumer, We are under a legal duty
                          to supply Products that are in conformity with the
                          Contract. Nothing in these terms and conditions will
                          affect your legal rights in relation to Products that
                          are faulty or defective.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          12.2. If you consider that any Product We have
                          supplied is faulty or mis-described, please notify us
                          using the contact details set out in clause 9.2.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          12.3. If you discover that your Product is faulty
                          after 14 days we reserve the right to request
                          evidence, such as images of the defect, before issuing
                          any refund of the price paid and/or any associated
                          delivery costs.
                        </p>
                      </div>
                      <h2>13. FAIR USAGE POLICY</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.1. To further protect against fraud and misuse of
                          our returns services, we have put together a Fair
                          Usage Policy. All returns and purchases must comply
                          with our Fair Usage Policy.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.2. Fraudulent, Suspicious, or Unusual Returns
                          Activity
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.3. Your account may be flagged for fraudulent,
                          suspicious, or unusual returns or purchasing activity.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.4. When reviewing your account, we will primarily
                          consider:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          excessive returns, far beyond the rest of our
                          customer-base; the number of orders placed; the
                          percentage of orders retained; the value of each
                          order; complaints about unreceived orders; missing
                          items; unusual activity patterns; returned items that
                          we suspect have been worn; returned items that have
                          signs of wear and tear; and returned items that do not
                          correspond with the order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.5. At our discretion, we reserve the right to
                          suspend or close your account. In serious cases, we
                          may also refuse to provide a refund and take legal
                          action where necessary.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.6. Following account suspension or closure, [you
                          will be required to pay the shipping cost for any
                          valid returns]. Valid returns will be refunded as
                          usual.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.7. In future, we may increase the cost of returns
                          for accounts that do not abide by the Fair Usage
                          Policy.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          13.8. Nothing in this Fair Usage Policy shall affect
                          your statutory rights.
                        </p>
                      </div>
                      <h2>14. OUR RIGHTS TO CANCEL THE CONTRACT</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          14.1. We may end the Contract at any time by writing
                          to you if:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (a) you do not make any payment to us when it is due;
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (b) you do not, within a reasonable time of us asking
                          for it, provide us with information that is necessary
                          for us to provide the Products; or
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          (c) you do not, within a reasonable time, allow us to
                          deliver the Products to you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          14.2. We may also end the Contract in the
                          circumstances set out in clause 6.2 or clause 7.5.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          14.3. If We end the Contract in any of the situations
                          set out in clause 12.1, We will refund any money you
                          have paid in advance for the Products We have not
                          provided but We may deduct or charge you reasonable
                          compensation for the costs We will incur as a result
                          of you breaking the Contract.
                        </p>
                      </div>
                      <h2>15. OUR LIABILITY</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          15.1. If We fail to comply with these terms and
                          conditions, We are responsible for loss or damage you
                          suffer that is a foreseeable result of our breach or
                          our failing to use reasonable care and skill, but We
                          are not responsible for any loss or damage that is not
                          foreseeable. Loss or damage is foreseeable if either
                          it is obvious that it will happen or if, at the time
                          the Contract was made, both We and you knew it might
                          happen.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          15.2. We only supply the Products for domestic and
                          private use. If you use the Products for any
                          commercial, business or resale purpose, We will have
                          no liability to you for any loss of profit, loss of
                          business, loss of anticipated savings, business
                          interruption or loss of business opportunity.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          15.3. We do not in any way exclude or limit our
                          liability for death or personal injury caused by our
                          negligence, fraud or fraudulent misrepresentation or
                          any matter for which We may not exclude or limit our
                          liability under any applicable law.
                        </p>
                      </div>
                      <h2>16. EVENTS OUTSIDE OUR CONTROL</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          16.1. We will not be liable or responsible for any
                          failure to perform, or delay in performance of, any of
                          our obligations under a Contract that is caused by an
                          Event Outside Our Control. An Event Outside Our
                          Control means any act, event, omission or accident
                          beyond our reasonable control.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          16.2. If an Event Outside Our Control takes place that
                          affects the performance of our obligations under a
                          Contract, We will contact you as soon as reasonably
                          possible to notify you and our obligations under the
                          Contract will be suspended and the time for
                          performance of our obligations will be extended for
                          the duration of the Event Outside Our Control. Where
                          the Event Outside Our Control affects our delivery of
                          Products to you, We will arrange a new delivery date
                          with you after the Event Outside Our Control is over.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          16.3. You may cancel a Contract affected by an Event
                          Outside Our Control if there is a risk of substantial
                          delay. To cancel a Contract under this clause 14
                          please contact us using the details set out in clause
                          8.2.
                        </p>
                      </div>
                      <h2>17. INTELLECTUAL PROPERTY RIGHTS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          17.1. All and any Intellectual Property Rights in the
                          Products shall be owned by us or our licensors. All
                          such rights are reserved.
                        </p>
                      </div>
                      <h2>18. OTHER IMPORTANT TERMS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.1. Nothing in these terms and conditions shall
                          affect your rights as a consumer under the applicable
                          law in the jurisdiction in which you are resident.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.2. We may change these terms and conditions from
                          time to time. The terms and conditions that apply to
                          your Contract will be those that are displayed on our
                          site when you place your order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.3. We may transfer our rights and obligations under
                          the Contract to another organisation. We will tell you
                          in writing if this happens and We will ensure that the
                          transfer will not affect your rights under the
                          Contract.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.4. You may only transfer your rights or your
                          obligations under these terms and conditions or the
                          Contract to another person if We agree in writing.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.5. Where the Contract relates to Products sold by a
                          Concessionaire Brand, the Contract is between you and
                          the relevant Concessionaire Brand. Alternatively,
                          where the Contract relates to Products sold by
                          boventraix , the Contract is between you and the
                          Concessionaire Brand. No other person shall have any
                          rights to enforce any of its terms.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.6. Each of the paragraphs of these terms and
                          conditions operates separately. If any court or
                          relevant authority decides that any of them are
                          unlawful or unenforceable, the remaining paragraphs
                          will remain in full force and effect.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.7. If We fail to insist that you perform any of
                          your obligations under these terms and conditions, or
                          if We do not enforce our rights against you, or if We
                          delay in doing so, that will not mean that We have
                          waived our rights against you and will not mean that
                          you do not have to comply with those obligations. If
                          We do waive a default by you, We will only do so in
                          writing, and that will not mean that We will
                          automatically waive any later default by you.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.8. Please note that these terms and conditions are
                          governed by English law. If you are a consumer, this
                          means a Contract for the purchase of Products and any
                          dispute or claim arising out of or in connection with
                          it will be governed by English law, except that if you
                          are not resident in England then English law shall
                          apply only to the extent that it does not override any
                          mandatory laws of the country in which you have your
                          usual place of residence.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          18.9. In respect of any dispute or claim relating to a
                          Contract, if you are a consumer you and We both submit
                          to the non-exclusive jurisdiction of the courts of
                          England and Wales, but nothing in this clause shall
                          limit your legal rights to bring actions against us or
                          to require proceedings to take place in the country in
                          which you have your usual place of residence. If you
                          are not a consumer, you and We both submit to the
                          exclusive jurisdiction of the courts of England and
                          Wales.
                        </p>
                      </div>
                      <h2>19. AFTER-SALES SERVICE</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          19.1. Questions, comments, requests or complaints
                          regarding these terms and conditions or any Product
                          supplied under a Contract with DBZ Marketplace Online
                          Limited should be addressed to{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          19.2. If you have any questions, comments, requests or
                          complaints regarding any Product supplied under a
                          Contract with a Concessionaire Brand these should be
                          addressed to{" "}
                          <Link
                            onClick={toTop}
                            to="mailto:style@boventraix.space"
                          >
                            style@boventraix.space
                          </Link>
                          .
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          19.3. If you are not satisfied with how We have
                          handled any complaint, you may wish to request that
                          the complaint be referred for alternative dispute
                          resolution (where an independent body considers the
                          facts of the dispute and seeks to resolve it without
                          you having to go to court). Disputes may be submitted
                          for online resolution to the European Commission
                          Online Dispute Resolution platform, which can be found{" "}
                          <Link onClick={toTop} to="/">
                            here
                          </Link>
                          .
                        </p>
                      </div>
                      <h2>
                        20. boventraix PREMIER - ANNUAL SUBSCRIPTION FOR
                        UNLIMITED DELIVERY
                      </h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.1. Membership – boventraix Premier is valid for 12
                          months and is only available to individuals residing
                          in the UK. To purchase boventraix Premier click{" "}
                          <Link onClick={toTop} to="/shipping">
                            here.
                          </Link>
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.2. boventraix Account - you must have a registered
                          boventraix customer account and be logged in to your
                          customer account to use boventraix Premier.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.3. Availability - boventraix Premier is available
                          for delivery to UK addresses. Please note postcode
                          restrictions apply.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.4. The service in the following areas may take 3 –
                          5 working days: Channel Islands, Highlands &amp;
                          Islands of Scotland, Shetlands.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.5. Minimum Spend – for all subscriptions after 12am
                          02.03.2023 (including renewals after this date)
                          boventraix premier free next-day delivery is available
                          for delivery to UK addresses on orders of £20 or over.
                          We reserve the right to amend the minimum spend order
                          of £20 during the applicable term, provided we give
                          reasonable notice to you. Orders below the spend of
                          £20 will be delivered as free standard delivery.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.6. Minimum Spend Changes – during your subscription
                          period, we may vary the minimum spend amount. In the
                          event of this, we will provide you with at least 30’
                          days written notice before any changes come into
                          effect. Should you decide not to continue with your
                          subscription because of the variation to the minimum
                          spend amount, you have the right to terminate your
                          subscription at any time before the minimum spend
                          change takes effect. You will receive a pro-rated
                          refund based on the number of full months left on your
                          subscription.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.7. Orders – you must place your order in accordance
                          with boventraix’s Next Day Delivery timescales.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.8. Returns – you shall be entitled to one free
                          return per order during your annual subscription. Any
                          additional items which are subsequently returned to us
                          in respect of the same order shall be at your cost
                          (currently priced at £1.99). boventraix reserves the
                          right to increase the price for additional returns in
                          respect of the same order.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.9. Delivery - boventraix reserves the right to
                          alter the delivery service valid in this promotion at
                          any time; in this case you will be offered the
                          delivery service available at that time free of
                          charge.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.10. Exclusions - The UK Next Day Evening Delivery
                          service (10pm to midnight) is expressly excluded from
                          boventraix Premier. - Thursday 26th November 2020 to
                          Wednesday 2nd December 2020 boventraix Premier Next
                          Day Delivery service will be unavailable.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.11. Terms &amp; Conditions – Terms &amp; Conditions
                          – You are responsible for using boventraix Premier in
                          accordance with the terms and conditions. boventraix
                          reserves the right to accept or refuse membership and
                          to change any terms and conditions at its discretion.
                          boventraix will inform you of any significant changes
                          to these terms and conditions. All other applicable
                          boventraix terms and conditions apply, including the
                          General Terms and Conditions and the Fair Use Policy.
                          Any breach will result in termination of your
                          membership and no refund will be given.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.12. Personal use only - boventraix Premier is for
                          personal use only.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.13. Delay outside of our control - boventraix will
                          not be held responsible for any delay or failure to
                          comply with our obligations if the delay or failure
                          arises from any cause which is beyond boventraix’s
                          reasonable control.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.14. Termination - We may decide to terminate your
                          boventraix Premier account and you will be given a
                          prorated refund based on the number of whole months
                          remaining in your membership. We will not give any
                          refund for termination related to conduct that we
                          determine, in our discretion, violates these terms or
                          any applicable law, involves fraud or misuse, or is
                          harmful to boventraix’s interests or another user.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.15. Postal address - boventraix Premier IS only
                          available for delivery to UK addresses. Please note
                          postcode restrictions apply.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The boventraix Premier service and boventraix Student
                          Premier in the following areas may take 3–5 working
                          days (rather than “next day”): Channel Islands,
                          Highlands &amp; Islands of Scotland, Shetlands.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.16. boventraix Premier Perks – boventraix may
                          introduce other temporary perks for members in such as
                          exclusive offers, promotions and free returns. These
                          perks may be cancelled, changes and withdrawn by
                          boventraix at any time without notice as they do not
                          form part of the Membership.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          20.17. The boventraix Premier service in the following
                          areas may take 3–5 working days (rather than “next
                          day”): Channel Islands, Highlands &amp; Islands of
                          Scotland, Shetlands.
                        </p>
                      </div>
                      <h2>21. PROMOTION TERMS AND CONDITIONS</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          21.1. Official boventraix promotion codes entitle you
                          to an offer on your online order from{" "}
                          <Link onClick={toTop} to="/">
                            www.boventraix.space
                          </Link>
                          . To utilise your promotion code, click the "redeem a
                          promotion code" button on the order summary page and
                          enter the specific code. Please note, promotion codes
                          can only be used once per transaction and cannot be
                          used in conjunction with any other promotion or offer.
                          Promotion codes are territory specific, remain our
                          property, are not transferable and are not valid for
                          the purchase of gift cards or gift vouchers. There is
                          no cash alternative. Promotion codes and related
                          offers are not open to employees of boventraix.space
                          and we reserve the right to withdraw them and refuse
                          or restrict any order at any time. Promotion codes are
                          only valid on boventraix.space for payments made by
                          residents of the United Kingdom and Ireland in
                          Sterling, where enabled, Euros, US or Australian
                          dollars. Payment by Euros, US or Australian dollars
                          can be enabled by selecting the appropriate flag in
                          the dropdown currency selection menu in the top
                          right-hand corner on the homepage.
                        </p>
                      </div>
                      <h2>22. SUBSCRIBE &amp; SAVE</h2>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          We offer a 5% discount for regularly scheduled
                          deliveries of Subscribe &amp; Save products on our
                          site (‘Subscribe &amp; Save’). All other T&amp;Cs
                          applies.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1 HOW TO SUBSCRIBE &amp; SAVE
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1.1 You will need to be logged into your boventraix
                          account to purchase items through Subscribe &amp;
                          Save.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1.2 Add a Subscribe &amp; Save product to your
                          basket.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1.3 Select your required frequency.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1.4 Click ‘Add to bag’.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.1.5 Review your order details and go to checkout.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.2 WHAT HAPPENS AFTER YOU SIGN UP
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Once you have subscribed to regular deliveries via the
                          our site, your selected products will be ordered and
                          delivered at the frequency you have selected
                          automatically without any further action required by
                          you. Before each Subscribe &amp; Save order is
                          dispatched to you, you will receive an order
                          confirmation message including order details and
                          instructions for cancelling future orders if you wish
                          to do so ("Order Confirmation"). The Subscribe &amp;
                          Save subscription constitutes a series of separate
                          offers from you to purchase a Subscribe &amp; Save
                          product (each an “order”). Each separate offer will be
                          deemed accepted when you receive the Order
                          Confirmation. If you wish to return a Subscribe &amp;
                          Save product, please see our Returns Policy.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.3 WHICH PRODUCTS ARE INCLUDED
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          All Subscribe &amp; Save products include a ‘Subscribe
                          &amp; Save’ option on the product page. boventraix
                          have sole discretion to determine which products are
                          “Subscribe &amp; Save” products and may change this at
                          any time without further notice.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.4 SUBSCRIBE &amp; SAVE DISCOUNT
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Each Subscribe &amp; Save order will be charged at the
                          price of the product at the time your order is
                          processed, with a 5% discount (the ‘Subscribe &amp;
                          Save Discount’). If a Subscribe &amp; Save product is
                          on sale at the time of purchase, the sale price will
                          apply alongside the Subscribe &amp; Save discount. THE
                          PRICE OF EACH SUBSCRIBE &amp; SAVE PRODUCT MAY
                          FLUCTUATE, WITHOUT FURTHER NOTICE. SUBSCRIBE &amp;
                          SAVE CANNOT BE USED IN CONJUNCTION WITH ADDITIONAL
                          PROMOTIONAL CODES OR VOUCHERS. boventraix RESERVES THE
                          RIGHT TO ADJUST THE RATE OF SUBSCRIBE &amp; SAVE
                          DISCOUNT AT ANY TIME.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.5 DELIVERY
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you have a boventraix Premier Membership, you will
                          get free next day delivery for each Subscribe &amp;
                          Save order until your  boventraix Premier Membership
                          expires. For all customers who do not have a
                           boventraix Premier Membership:
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          All orders will default to standard delivery.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you select any other delivery option at check-out,
                          it will only apply to your first order and all
                          subsequent orders will revert to standard delivery.
                          For more information on delivery, click here.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.6 PAYMENT METHOD
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          The credit or debit card you use to initially
                          subscribe to Subscribe &amp; Save will be billed for
                          each subsequent order. We can only accept payment by
                          credit or debit card for Subscribe &amp; Save.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.7 CANCELLATION
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If your subscription is cancelled: • You will receive
                          an email confirming the cancellation. • You will only
                          be billed for Subscribe &amp; Save orders for which
                          you have already received Order Confirmation. • No
                          additional Subscribe &amp; Save orders will be placed
                          for that Subscribe &amp; Save Product.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.7.1. HOW TO CANCEL OR MODIFY YOUR SUBSCRIPTIONS
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          Your Subscribe &amp; Save subscription will continue
                          until cancelled. If you wish to cancel your Subscribe
                          &amp; Save subscription, you must give us 30-days
                          notice. You can do this here. . YOUR SUBSCRIBE &amp;
                          SAVE SUBSCRIPTION WILL BE AUTOMATICALLY CANCELLED 30
                          DAYS AFTER YOU NOTIFY US OF YOUR WISH TO CANCEL.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.7.2. COOLING OFF
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          If you change your mind after subscribing, you are
                          entitled to a 14-day cancellation period. To request a
                          cancellation, please head over to our{" "}
                          <Link onClick={toTop} to="/contact">
                            contact us
                          </Link>{" "}
                          section.
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          22.7.3 OUR RIGHT TO CANCEL
                        </p>
                      </div>
                      <div>
                        <p className="mx-auto px-6" node="[object Object]">
                          boventraix and/or the relevant Concessionaire Brand
                          may cancel your Subscribe &amp; Save subscription at
                          any time. This includes where problems arise with your
                          payment method, delivery address, or product
                          availability.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Terms;
